import { HttpStatus } from '../errors';

export enum Errors {
  SERVICE_NOT_AVAILABLE = HttpStatus.INTERNAL_SERVER_ERROR,
}
